/** WordPress names resized copies `photo-500x375.jpg` next to the original `photo.jpg`. */
const SIZE_SUFFIX_RE = /-(\d+)x(\d+)(\.[a-z0-9]+)$/i;

/**
 * Keep one copy of each photo when a page lists it at several sizes.
 *
 * Recipe plugins publish the same photo as the original plus square, 4:3 and 16:9
 * crops so search engines can pick a shape, which would otherwise import as four
 * near-identical photos. The original wins; failing that, the largest crop does.
 * Distinct photos keep the order they were listed in.
 */
export function collapseImageSizeVariants(urls: readonly string[]): string[] {
  const best = new Map<string, { url: string; area: number }>();
  for (const url of urls) {
    const { key, area } = sizeVariant(url);
    const current = best.get(key);
    if (current == null || area > current.area) best.set(key, { url, area });
  }
  return [...best.values()].map((entry) => entry.url);
}

function sizeVariant(url: string): { key: string; area: number } {
  const queryStart = url.search(/[?#]/);
  const path = queryStart === -1 ? url : url.slice(0, queryStart);
  const match = SIZE_SUFFIX_RE.exec(path);
  if (match == null) return { key: path, area: Infinity };
  const key = path.slice(0, match.index) + match[3];
  return { key, area: Number(match[1]) * Number(match[2]) };
}
